import { GetServerSideProps, NextPage } from 'next';
import React from 'react';

import { pagesConfigStore } from '~/atomic/atom/links/pagesConfigStore';
import { CommonLayout } from '~/atomic/layout/CommonLayout';
import { LayoutType } from '~/atomic/layout/DefaultLayout';
import { PageTemplate } from '~/atomic/organism/PageTemplate/PageTemplate';
import { ContestZhenitNelzyaPomilovat } from '~/atomic/page/contest/ContestZhenitNelzyaPomilovat';
import { checkAuthToken } from '~/feature/authorization/checkAuthToken';
import { createStore, RootState } from '~/store';

const ContestEverythingWillBeFinePage: NextPage & LayoutType = () => {
  const title = 'Конкурс фэнтезийных любовных романов «Женить нельзя помиловать»!';

  return (
    <PageTemplate
      isPublic={pagesConfigStore.contestZhenitNelzyaPomilovat.isPublic}
      seo={{
        title,
        image: 'https://storage.bookriver.ru/storage/banners/zhenit-nelzya-pomilovat.jpg',
        canonical: pagesConfigStore.contestZhenitNelzyaPomilovat.url,
      }}
      content={(
        <ContestZhenitNelzyaPomilovat />
      )}
    />
  );
};

ContestEverythingWillBeFinePage.getLayout = (page) => (
  <CommonLayout>{ page }</CommonLayout>
);

export const getServerSideProps: GetServerSideProps<{ state: RootState; }> = async (ctx) => {
  const { store, dispatch } = await createStore();
  const isLoggedIn = await checkAuthToken(ctx, dispatch);

  const state = store.getState();

  return { props: { state } };
};

export default ContestEverythingWillBeFinePage;
